function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "#b58e3b"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M60 49.114a5 5 0 01-2.5 4.329l-25 14.444a5 5 0 01-5 0l-25-14.444A5 5 0 010 49.114v-28.9a5 5 0 012.5-4.329l25-14.44a5 5 0 015 0l25 14.445a5 5 0 012.5 4.329z"
}),
/*#__PURE__*/
React.createElement("path", {
  d: "M55 20.219L30 5.775 5 20.219v28.895L30 63.56l25-14.445V20.22m5 0v28.895a5 5 0 01-2.499 4.33l-25 14.444a5 5 0 01-5.002 0l-25-14.444A5 5 0 010 49.114V20.22a5 5 0 012.499-4.33l25-14.444a5 5 0 015.002 0l25 14.445A5 5 0 0160 20.219z",
  fill: "rgba(255,255,255,.21)"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  d: "M27.168 51a1.681 1.681 0 01-1.191-.491L14.493 39.022a1.692 1.692 0 010-2.388l15.15-14.751a3.367 3.367 0 012.137-.881h10.531A1.69 1.69 0 0144 22.691v10.531a3.376 3.376 0 01-.889 2.144L28.372 50.5a1.7 1.7 0 01-1.204.5zm4.612-28.522a1.941 1.941 0 00-1.1.456L15.529 37.685a.207.207 0 00-.054.144.211.211 0 00.061.15L27.02 49.465a.217.217 0 00.3 0L42.059 34.33a1.951 1.951 0 00.463-1.107V22.692a.215.215 0 00-.213-.213z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  d: "M38.344 29.361a2.7 2.7 0 112.705-2.7 2.708 2.708 0 01-2.705 2.7zm0-3.934a1.229 1.229 0 101.229 1.229 1.23 1.23 0 00-1.229-1.229zM24.052 41.426a.734.734 0 010-1.043l.87-.87-.87-.867a.738.738 0 011.043-1.044l1.392 1.389a1.229 1.229 0 001.738-1.737 2.706 2.706 0 013.231-4.277l.942-.939a.734.734 0 011.043 0 .742.742 0 010 1.044l-.869.866.869.871a.738.738 0 01-1.043 1.043l-1.388-1.389a1.23 1.23 0 00-1.742 1.738 2.705 2.705 0 01-3.231 4.274l-.942.941a.739.739 0 01-1.043 0z"
});

var SvgAchievementBigTicket = function SvgAchievementBigTicket(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      viewBox: "0 0 60 70",
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2, _ref3, _ref4)
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgAchievementBigTicket, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/AchievementBigTicket.b472738c.svg";
export { ForwardRef as ReactComponent };